import { render, staticRenderFns } from "./NoteAdd.vue?vue&type=template&id=29fa1c6a&scoped=true&"
import script from "./NoteAdd.vue?vue&type=script&lang=js&"
export * from "./NoteAdd.vue?vue&type=script&lang=js&"
import style0 from "./NoteAdd.vue?vue&type=style&index=0&id=29fa1c6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fa1c6a",
  null
  
)

export default component.exports